module.exports = __webpack_public_path__ + "img/chart-up.b36f8298.svg";